import { fillHistoryUpdateReportApi } from 'api/prescription';
import PropTypes from 'prop-types';
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleError } from 'store/thunks/errorHandlerThunks';

const FillHistoruUpdateReportContext = createContext();

export const FillHistoryUpdateReportProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const [count, setCount] = useState(0);
  const [fillHistoryUpdateReports, setFillHistoryUpdateReports] = useState(undefined);
  const [page, setPage] = useState(1);

  const searchFillHistoryUpdateReports = useCallback(() => {
    setCount(0);
    setFillHistoryUpdateReports(null);
    return fillHistoryUpdateReportApi({ limit: 25, offset: page - 1, filter })
      .then((data) => {
        setCount(data.count);
        setFillHistoryUpdateReports(data.result);
      })
      .catch((error) => dispatch(handleError({ error })));
  }, [dispatch, filter, page]);

  const value = useMemo(
    () => ({ fillHistoryUpdateReports, setFilter, count, setPage, page, filter }),
    [fillHistoryUpdateReports, count, page, filter]
  );

  useEffect(() => {
    searchFillHistoryUpdateReports();
  }, [searchFillHistoryUpdateReports]);

  return (
    <FillHistoruUpdateReportContext.Provider value={value}>
      {children}
    </FillHistoruUpdateReportContext.Provider>
  );
};

FillHistoryUpdateReportProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useFillHistoryUpdateReport = () => useContext(FillHistoruUpdateReportContext);
